import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    /**
     * Intent Routes are opening Model over the previous Route
     * Because of <ScrollToTop />, it was changing the Scroll position
     * making the User not able to continue from the previous point
     */
    if (state?.scrollToTop === undefined || state?.scrollToTop) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
